// Copyright (c) 2022 by Move Closer

import { ImageData, ProductSneakPeakData, Price } from '../../../../contexts'

import { Variant as VariantSwitchVariant } from './VariantsSwitch.contracts'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl> (original)
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl> (edited)
 */
export const translateProductVariantsToVariantsSwitch = (
  product: ProductSneakPeakData,
  type: string
): VariantSwitchVariant[] => {
  const { variants, variantSelector } = product
  if (typeof variantSelector === 'undefined') {
    return []
  }

  return variantSelector[type].map(({ slug, label, value }) => {
    let identifierLabel: string = ''
    const identifier: string | ImageData = value || label
    const variantSlug = Object.keys(variants).filter((key) => key.includes(slug))[0]
    const variant = variants[variantSlug]
    const isAvailable = (variant.isAvailable) || false
    const hasDiscount = (variant.price.finalPrice < variant.price.regularPrice) || false

    if (variant.identifier[type]) {
      identifierLabel = variant.identifier[type]
    }

    return {
      slug,
      identifier,
      identifierLabel,
      isAvailable,
      name: variant.name,
      price: variant.price,
      hasDiscount
    }
  })
}

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const translateProductToVariantsSwitch = (
  product: ProductSneakPeakData,
  type: string
): VariantSwitchVariant[] => {
  const { variants, variantSelector } = product
  if (typeof variantSelector === 'undefined') {
    return []
  }

  // console.log('==========================product==========================')
  // console.log(product)

  return variantSelector[type].map(({ slug, label, value }) => {
    const variant = Object.values(variants).find(variant => variant.identifier.color === slug)

    const identifierLabel: string = ''
    const identifier: string | ImageData = value || label

    return {
      slug,
      identifier,
      identifierLabel,
      isAvailable: variant?.isAvailable ?? false,
      name: variant?.name ?? '',
      price: variant?.price as Price,
      hasDiscount: false
    }
  })
}
